function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "awstats",
  d: "M37.913,34.342H2.25L9.515,20.72a1.1,1.1,0,0,1,.661-.515,1.247,1.247,0,0,1,.866.021v-.041q-.166-.123-.123-.123.082,0,.371.248a1.265,1.265,0,0,1,.454.619l1.444,1.444,7.636-10.856a1.146,1.146,0,0,1,.289-.578,1.286,1.286,0,0,1,.95-.371,1.38,1.38,0,0,1,.95.371.2.2,0,0,0,.041.1l.041.062,3.674,2.972L36.674.908A1.231,1.231,0,0,1,37.913,0h.041a1.234,1.234,0,0,1,.908.371,1.234,1.234,0,0,1,.371.908V33.02a1.341,1.341,0,0,1-1.32,1.322Z",
  transform: "translate(-2.25)",
  fill: "#ac1ede"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "success-line",
  d: "M7.953,16.535,3.16,11.746a.46.46,0,0,1,.648-.648l4.136,4.136L16.027,7.16a.46.46,0,0,1,.648.648Z",
  transform: "translate(4.875 -5.876)",
  fill: "none",
  stroke: "#ac1ede",
  strokeWidth: 1
});

var SvgAwstats = function SvgAwstats(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_37_2",
    "data-name": "Component 37 \\u2013 2",
    width: 36.982,
    height: 34.342,
    viewBox: "0 0 36.982 34.342",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAwstats, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/awstats.c724e13c.svg";
export { ForwardRef as ReactComponent };